import { render, staticRenderFns } from "./lipstickbar-index.vue?vue&type=template&id=5c011d56&"
import script from "./lipstickbar-index.vue?vue&type=script&lang=js&"
export * from "./lipstickbar-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports